import styled from '@emotion/styled';
import React from 'react';
import { colors } from '../../../utils/styleguide';
import ContentfulFooter from '../../contentful-elements/footer/ContentfulFooter';
import DefaultFooter from '../../contentful-elements/footer/DefaultFooter';
import { FooterBarServerProps } from '../../contentful-elements/util/navigation';
import { FooterPagesItemType } from '../navigation/navTypes';

const Layout = styled.nav<Props>`
  background-color: ${colors.black};
  margin: 0 auto;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
`;

type Props = {
  footerPages?: FooterPagesItemType[];
  footerBar?: FooterBarServerProps;
  showLanguageSelection?: boolean;
  hasMobileStaticButton?: boolean;
};

const Footer = ({
  footerPages,
  footerBar,
  showLanguageSelection,
  hasMobileStaticButton = false,
}: Props) => {
  return (
    <Layout aria-label="Footer">
      {footerBar ? (
        <ContentfulFooter footerBar={footerBar} />
      ) : (
        <DefaultFooter
          pages={footerPages}
          showLanguageSelection={showLanguageSelection}
          hasMobileStaticButton={hasMobileStaticButton}
        />
      )}
    </Layout>
  );
};

export default Footer;
